import { TbIcon } from 'components/Figma';
import { IconName } from 'components/Figma/_generated/icons.registry';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface TitleCardProps {
  title: string;
  icon: IconName;
  isPromotion?: boolean;
  isLast?: boolean;
}

export function RowTitleCard({ title, icon, isPromotion = false, isLast = false }: TitleCardProps) {
  return (
    <div
      className={`col-span-2 xl:col-span-2 flex  h-full py-4 cursor-default items-center${isLast ? '' : ' border-b-2'}`}
    >
      <div className={`${isPromotion ? 'bg-denim-50' : 'bg-ash-900 bg-opacity-5'} px-1 mr-1 rounded-lg`}>
        <TbIcon name={icon} />
      </div>
      <Typography variant="h6">
        <FormattedMessage id={title} />
      </Typography>
    </div>
  );
}
